<template>
  <div class="my_header">
    <div
      v-if="Object.keys(siteInfo).length"
      class="content_w d_flex align_item_c site_min_w"
      :style="{
        background: `url('${
          siteInfo.slideshows[0] ||
          `${oss_pub_domain}site/article/cover/e0ZvmZpn6UAGQQ20.png`
        }') center center/cover no-repeat`,
      }"
    >
      <div class="center_w d_flex align_item_c site_content">
        <h1 class="logo_w">
          <div class="cursor_pointer" @click="reloadHome">
            <img class="logo_style" :src="siteInfo.logo" alt="" />
          </div>

        </h1>
        <slot name="location" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TipsBar from "@/components/public/TipsBar.vue";
export default {
  components: {
    TipsBar,
  },
  data() {
    return {
      a: 1,
    };
  },

  computed: {
    ...mapGetters(["siteInfo", "oss_pub_domain"]),
  },
  methods: {
    reloadHome() {
      location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.cursor_pointer02 {
  margin-left: 65px;
  position: relative;
  top: -10px;
  font-size: 12px;
  font-weight: 600;
  text-shadow: -1px -1px 0 #dfdad9, 1px -1px 0 #dfdad9, -1px 1px 0 #dfdad9,
    1px 1px 0 #dfdad9;
  /* 可选：平滑过渡 */
  transition: text-shadow 0.3s;
}
.my_header {
  height: 140px;
  .content_w {
    height: 100%;
  }
  .center_w {
    position: relative;
  }
  .logo_w {
    display: inline-block;
  }
  .div_1 {
  }
}
.text {
  font-size: 22px;
  font-weight: 1000;
  -webkit-text-stroke: 1px white; /* WebKit浏览器（如Chrome, Safari） */
  color: black; /* 文字颜色 */
}
</style>
